import { render, staticRenderFns } from "./customText.vue?vue&type=template&id=63005975&scoped=true"
import script from "./customText.vue?vue&type=script&lang=js"
export * from "./customText.vue?vue&type=script&lang=js"
import style0 from "./customText.vue?vue&type=style&index=0&id=63005975&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63005975",
  null
  
)

export default component.exports